export default "__VITE_ASSET__DXAP1aEn__"